import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsContent, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'fin-editorial-category',
  templateUrl: './editorial-category.component.html',
  styleUrls: ['./editorial-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditorialCategoryComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  editorialCategory = input<CmsContent>();

  segmentId = computed(() => {
    const { segment, contentId } = this.editorialCategory();
    return segment !== JSON.stringify(contentId) ? segment : null;
  });

  items = computed(() => {
    return (this.editorialCategory().items ?? []).map((item) => {
      return { ...item, isShowAllLink: item.subjectTaxonomyTags.includes(CmsTaxonomyGeneral.ARROW_LINK) };
    });
  });
}
